import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Spinner
 */
const Spinner = props => {
  const children = props.children || null;
  const Tag = props.tag;
  return /*#__PURE__*/React.createElement(Tag, {
    role: "status",
    className: classNames({
      'spinner-border': props.type === 'bordered',
      'spinner-grow': props.type === 'grow'
    }, [`text-${props.color}`], {
      [`avatar-${props.size}`]: props.size
    }, props.className)
  }, children);
};

Spinner.defaultProps = {
  tag: 'div',
  type: 'bordered',
  color: 'primary'
};
export default Spinner;